import React from "react";
import "./Contacts.css";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const Contacts = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8anmfi8",
        "template_w9sel2t",
        form.current,
        "8jhKoF3k19q3pXZwh"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("email sent");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <>
      <section id="contacts">
        <p>
          <b>Let's Talk</b>
        </p>
        <div className="form">
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              placeholder="your name"
              id="name"
              name="user_name"
              required
            ></input>
            <br></br>
            <input
              type="email"
              placeholder="email address"
              id="email"
              name="user_email"
              required
            ></input>
            <br></br>
            <textarea
              id="comments"
              placeholder="write your message here..."
              name="message"
              required
            ></textarea>
            <br></br>
            <button type="submit" id="send" value="send">
              Reach Me
            </button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Contacts;
